import React, { useState } from "react";
import "./AlumniDropdown.css";

function getYearFromRollNo(person) {
  const match = String(person.rollNo || "").match(/\d{2}/);

  if (!match) {
    return "Year unavailable";
  }

  const year = Number(match[0]);
  return String(year < 50 ? 2000 + year : 1900 + year);
}

function groupPeopleByYear(people) {
  if (Array.isArray(people)) {
    return people.reduce((groups, person) => {
      const year = getYearFromRollNo(person);
      return {
        ...groups,
        [year]: [...(groups[year] || []), person],
      };
    }, {});
  }

  return people || {};
}

function sortYearLabels(a, b) {
  const first = Number(a);
  const second = Number(b);

  if (Number.isFinite(first) && Number.isFinite(second)) {
    return second - first;
  }

  return a.localeCompare(b);
}

const AlumniDropdown = ({ title = "Alumni", people, alumni }) => {
  const [expandedYear, setExpandedYear] = useState(null);

  const peopleByYear = groupPeopleByYear(people || alumni);
  const years = Object.keys(peopleByYear)
    .filter((year) => Array.isArray(peopleByYear[year]) && peopleByYear[year].length > 0)
    .sort(sortYearLabels);

  const toggleYear = (year) => {
    setExpandedYear(expandedYear === year ? null : year);
  };

  if (!years.length) {
    return null;
  }

  return (
    <div className="mt-6">
      <h3 className="text-2xl font-semibold mb-4 text-gray-800">{title}</h3>
      <div className="space-y-3">
        {years.map((year) => (
          <div key={year} className="border border-gray-300 rounded-lg overflow-hidden">
            <button
              className="w-full px-4 py-3 bg-gray-100 hover:bg-[#e8f0f0] text-left font-medium text-gray-800 flex justify-between items-center transition-all duration-300"
              onClick={() => toggleYear(year)}
            >
              <div className="flex items-center gap-2">
                <span className="text-gray-800">{year}</span>
                <span className="text-gray-600">({peopleByYear[year].length})</span>
              </div>
              <span className={`text-[#2d5d6d] font-bold transition-transform duration-400 ${expandedYear === year ? 'rotate-180' : ''}`}>
                ▼
              </span>
            </button>

            <div className={`alumni-content bg-white divide-y divide-gray-200 ${expandedYear === year ? 'open' : ''}`}>
              <div className="alumni-content-inner">
                {peopleByYear[year].map((person, idx) => (
                  <div key={idx} className="p-4 hover:bg-gray-50 transition-colors">
                    <div className="font-medium text-gray-900 mb-1">{person.name}</div>
                    {person.rollNo ? (
                      <div className="text-sm text-gray-700 mb-1">{person.rollNo}</div>
                    ) : (
                      <>
                        <div className="text-sm text-gray-700 mb-1">
                          <strong>{person.degree}</strong> • {person.specialization}
                        </div>
                        {person.currentRole && (
                          <div className="text-sm text-gray-600 italic">{person.currentRole}</div>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlumniDropdown;
